import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { routeNames } from '../../../routes/routeNames';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';

const BookOnlineSection = () => {
  return (
    <div className=' flex items-center justify-center mt-4'>
      <div className="bg-gradient-to-br from-darkBackground to-primary text-white p-6 rounded-xl shadow-lg flex flex-col items-center justify-center w-[75%] py-10 lg:w-[60%]">
      <h2 className="text-xl md:text-2xl font-bold text-center mb-4">
        Eliminate Pain and Improve Overall Health & Wellness
      </h2>
      <ul className="list-none space-y-3 text-center my-4">
        <li className='flex items-center'><IoMdCheckmarkCircleOutline className='h-5 w-5 mx-1'/> Personalized 1:1 Care</li>
        <li className='flex items-center'><IoMdCheckmarkCircleOutline className='h-5 w-5 mx-1'/> Effective Pain Relief</li>
        <li className='flex items-center'><IoMdCheckmarkCircleOutline className='h-5 w-5 mx-1'/> Improved Movements</li>
      </ul>
      <Link to={routeNames.contact} className="bg-orange hover:bg-orange-600 text-white font-bold py-3 px-4 rounded-full inline-flex items-center mt-4 transition duration-300">
        Book Online <FaArrowRight className="ml-2" />
      </Link>
    </div>
    </div>
  );
};

export default BookOnlineSection;
